export default [
  {
    path: '/entrar',
    component: () => import('./Login.vue'),
    children: [
      {
        name: 'Login',
        path: '',
        component: () => import('./content/LoginAccess.vue'),
        meta: {
          isPublic: true,
        },
      },
    ],
    meta: {
      isPublic: true,
      hideTopbar: true,
      title: 'Entrar',
    },
  },
  {
    path: '/cadastrar',
    component: () => import('./Login.vue'),
    children: [
      {
        name: 'Register',
        path: '',
        component: () => import('./content/LoginRegister.vue'),
        meta: {
          isPublic: true,
        },
      },
    ],
    meta: {
      isPublic: true,
      hideTopbar: true,
      title: 'Cadastrar',
    },
  },
  {
    path: '/sair',
    component: () => import('./Login.vue'),
    children: [
      {
        name: 'Logout',
        path: '',
        component: () => import('./content/LoginLogout.vue'),
        meta: {
          isPublic: true,
        },
      },
    ],
    meta: {
      isPublic: true,
      hideTopbar: true,
      title: 'Sair',
    },
  },
  {
    path: '/esqueci-senha',
    component: () => import('./Login.vue'),
    children: [
      {
        name: 'ForgetPassword',
        path: '',
        component: () => import('./content/LoginForgetPassword.vue'),
        meta: {
          isPublic: true,
        },
      },
    ],
    meta: {
      isPublic: true,
      hideTopbar: true,
      title: 'Esqueci Senha',
    },
  },
  {
    path: '/recuperar-senha/:email',
    component: () => import('./Login.vue'),
    children: [
      {
        name: 'RecoveryPassword',
        path: '',
        component: () => import('./content/LoginRecoveryPassword.vue'),
        meta: {
          isPublic: true,
        },
      },
    ],
    props: true,
    meta: {
      isPublic: true,
      hideTopbar: true,
      title: 'Recuperar Senha',
    },
  },
];
